export default "__VITE_ASSET__CKumCZus__"